import React from "react";
import { Mycustombutton } from "./MyCustomButton/Mycustombutton";
import btnStyle from "./MyCustomButton/Mycustombutton.css";


const ActionCustomButton = ({
  _action,
  showInvitationDialog,
  handleEventServiceClick,
  service,
}) => {
  const handleClick = () => {
    switch (_action) {
      case "book_priest_button":
      case "book_tent_button":
      case "book_catering_button":
        console.log(
          "Service Action button clicked",
          service,
          handleEventServiceClick
        );
        if (handleEventServiceClick && service) {
          console.log("Event menthod is there with service");
          handleEventServiceClick(service);
        }
        // perform logic here or call a function
        break;

      case "send_invitation_button":
        if (showInvitationDialog) {
          console.log("Show invitation is there");
          showInvitationDialog(true);
        }
        console.log("Send Invitation button clicked");
        break;
      default:
        console.warn("Unknown action button clicked");
    }
  };

  const getButtonLabel = () => {
    switch (_action) {
      case "book_priest_button":
        return "Book a Priest";
      case "book_tent_button":
        return "Rent from Tent Houses";
      case "book_catering_button":
        return "Order Catering";
      case "send_invitation_button":
        return "Send Invitation";
      default:
        return null;
    }
  };

  const label = getButtonLabel();
  if (!label) return null;

  return (
    <Mycustombutton
      label={label}
      onClick={handleClick}
      className={btnStyle.blueActionBtn}
    />
  );
};

export default ActionCustomButton;
